
import React, { useState } from 'react';

export default function AdminLogin({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [msg, setMsg] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMsg('');
    try {
      const res = await fetch(`/api/adminAuth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password })
      });
      const data = await res.json();
      if (data.token) {
        localStorage.setItem('adminToken', data.token);
        if (data.message.includes('挤下线') || data.message.includes('其他地方登录')) {
          alert('登录成功！已挤掉其他地方的登录。');
        }
        onLogin();
      } else {
        setMsg(data.message || '登录失败');
      }
    } catch (error) {
      setMsg('网络错误，请稍后再试');
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <form onSubmit={handleSubmit} className="card" style={{ maxWidth: 320, margin: '40px auto' }}>
      <h2 style={{textAlign: 'center', marginTop: 40, marginBottom: 40, fontSize:26 }}>管理员登录</h2>
      <input 
        value={username} 
        onChange={e => setUsername(e.target.value)} 
        placeholder="用户名" 
        required 
        className="input" 
        style={{ width: '100%', marginBottom: 50, height: 40 }} 
      />
      <div style={{ position: 'relative', marginBottom: 40 }}>
        <input
          type={showPassword ? 'text' : 'password'}
          value={password}
          onChange={e => setPassword(e.target.value)}
          placeholder="密码"
          required
          className="input"
          style={{ 
            width: '100%', 
            paddingRight: 40,
            height: 40,
            boxSizing: 'border-box'
          }}
        />
        <button
          type="button"
          onClick={togglePasswordVisibility}
          style={{
            right: 10,
            position: 'absolute',
            //background: 'none',
            backgroundColor: '#72b6fe',
            border: 'none',
            cursor: 'pointer',
            color: '#ffffff',
            height: 24,
            padding:'0 5px',
            marginTop: 8
          }}
        >
          {showPassword ? '隐/显' : '显/隐'}
        </button>
      </div>
      <button type="submit" style={{ width: '100%', marginTop: 20, marginBottom: 20, height: 40 }}>登录</button>
      {msg && <div style={{ color: 'var(--danger-color)', marginTop: 20, marginBottom: 20, textAlign: 'center' }}>{msg}</div>}
    </form>
  );
}
